import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const useGetList = (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  return useQuery(
    ["students", schoolId, trainingId, accessToken, page, pageSize, filter],
    async () => {
      let levelId = filter?.level_id;
      if (levelId === undefined) {
        levelId = "";
      }
      let classeId = filter?.classe_id;
      if (classeId === undefined) {
        classeId = "";
      }
      let searchName = filter?.name;
      if (searchName === undefined) {
        searchName = "";
      }
      let memberId = filter?.member_id;
      if (memberId === undefined) {
        memberId = "";
      }
      let status = filter?.status;
      if (status === undefined) {
        status = "";
      }
      let previousTrainingResult = filter?.previous_result;
      if (previousTrainingResult === undefined) {
        previousTrainingResult = "";
      }
      let isRegistrationNew = filter?.registration_new;
      if (isRegistrationNew === undefined) {
        isRegistrationNew = "";
      }
      let previousLevelName = filter?.previous_level_name;
      if (previousLevelName === undefined) {
        previousLevelName = "";
      }
      let previousClassName = filter?.previous_class_name;
      if (previousClassName === undefined) {
        previousClassName = "";
      }
      let hasContract = filter?.has_contract;
      if (hasContract === undefined || hasContract === "") {
        hasContract = "";
      } else if (hasContract === "true") {
        hasContract = "true";
      } else if (hasContract === "false") {
        hasContract = "false";
      }
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/students?page=${page}&pageSize=${pageSize}&level_id=${levelId}&class_id=${classeId}&name=${searchName}&member_id=${memberId}&status=${status}&previous_result=${previousTrainingResult}&is_new=${isRegistrationNew}&previous_level_name=${previousLevelName}&previous_class_name=${previousClassName}&has_contract=${hasContract}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch students!");
        }
        if (response.status >= 299) {
          throw new Error("Erreur de récupération de la liste des élèves!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        // Handle the error
        console.error("Error fetching students:", error);
        throw error;
      }
    },
    {
      // Keep previous data while loading new data to prevent flickering
      keepPreviousData: true,
      // Stale time to prevent unnecessary refetches
      staleTime: 30000, // 30 seconds
      // Cache time for better performance
      cacheTime: 300000, // 5 minutes
      // Refetch on window focus only if data is stale
      refetchOnWindowFocus: false,
      // Retry failed requests
      retry: 2,
      // Retry delay
      retryDelay: 1000,
    }
  );
};

const useGetOngoingList = (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  return useQuery(
    ["students-registred", schoolId, trainingId, accessToken, page, pageSize, filter],
    async () => {
      let levelId = filter?.level_id;
      if (levelId === undefined) {
        levelId = "";
      }
      let classeId = filter?.classe_id;
      if (classeId === undefined) {
        classeId = "";
      }
      let searchName = filter?.name;
      if (searchName === undefined) {
        searchName = "";
      }
      let memberId = filter?.member_id;
      if (memberId === undefined) {
        memberId = "";
      }
      let previousTrainingResult = filter?.previous_result;
      if (previousTrainingResult === undefined) {
        previousTrainingResult = "";
      }
      let studentResult = filter?.result;
      if (studentResult === undefined) {
        studentResult = "";
      }
      let minAbsences = filter?.min_absences;
      if (minAbsences === undefined) {
        minAbsences = "";
      }
      let minRetards = filter?.min_retards;
      if (minRetards === undefined) {
        minRetards = "";
      }

      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/students?page=${page}&pageSize=${pageSize}&level_id=${levelId}&class_id=${classeId}&name=${searchName}&member_id=${memberId}&status=ENROLLED&previous_result=${previousTrainingResult}&result=${studentResult}&min_absences=${minAbsences}&min_retards=${minRetards}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch students!");
        }
        if (response.status >= 299) {
          throw new Error("Erreur de récupération de la liste des élèves!");
        }
        const queryResult = await response.json();
        return queryResult;
      } catch (error) {
        // Handle the error
        console.error("Error fetching students:", error);
        throw error;
      }
    },
    {
      // Options for react-query useQuery
      // Keep previous data while loading new data to prevent flickering
      keepPreviousData: true,
      // Data is considered fresh for 30 seconds
      staleTime: 30000, // 30 seconds
      // Cache data for 5 minutes to improve performance
      cacheTime: 300000, // 5 minutes
      // Do not refetch on window focus unless data is stale
      refetchOnWindowFocus: false,
      // Retry failed requests up to 2 times
      retry: 2,
      // Wait 1 second between retry attempts
      retryDelay: 1000,
    }
  );
};

const SearchStudent = async (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  let levelId = filter?.level_id;
  if (levelId === undefined) {
    levelId = "";
  }
  let classeId = filter?.classe_id;
  if (classeId === undefined) {
    classeId = "";
  }
  let searchName = filter?.name;
  if (searchName === undefined) {
    searchName = "";
  }
  let memberId = filter?.member_id;
  if (memberId === undefined) {
    memberId = "";
  }
  let status = filter?.status;
  if (status === undefined) {
    status = "";
  }
  try {
    const response = await fetch(
      BACKEND_URL +
      `/api/v1/schools/${schoolId}/trainings/${trainingId}/students?page=${page}&pageSize=${pageSize}&level_id=${levelId}&class_id=${classeId}&name=${searchName}&member_id=${memberId}&status=${status}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch students!");
    }
    if (response.status >= 299) {
      throw new Error("Erreur de récupération de la liste des élèves!");
    }
    const result = await response.json();
    return result;
  } catch (error) {
    // Handle the error
    console.error("Error fetching students:", error);
    throw error;
  }
};

const GetOne = (schoolId, trainingId, accessToken, studentId) => {
  return useQuery(
    ["student", schoolId, trainingId, accessToken, studentId],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/students/${studentId}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Erreur de récupération de l'élève!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        throw error;
      }
    }
  );
};

const ListSiblings = (schoolId, trainingId, accessToken, studentId) => {
  return useQuery(
    ["student-siblings", schoolId, trainingId, accessToken, studentId],
    async () => {
      const response = await fetch(
        BACKEND_URL +
        `/api/v1/schools/${schoolId}/trainings/${trainingId}/students/${studentId}/siblings`,
        {
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Erreur de récupération des frères et sœurs!");
      }
      const result = await response.json();
      return result;
    },
    {
      enabled: !!studentId, // Only run the query when studentId is defined
    }
  );
};

const ListAttendances = (schoolId, trainingId, accessToken, studentId) => {
  return useQuery(
    ["student-attendances", schoolId, trainingId, accessToken, studentId],
    async () => {
      const response = await fetch(
        BACKEND_URL +
        `/api/v1/schools/${schoolId}/trainings/${trainingId}/students/${studentId}/attendances`,
        {
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Erreur de récupération des absences et retards!");
      }
      const result = await response.json();
      return result;
    },
    {
      enabled: !!studentId,
    }
  );
};

const observationsUrl = (schoolId, trainingId, studentId) =>
  `${BACKEND_URL}/api/v1/schools/${schoolId}/trainings/${trainingId}/students/${studentId}/observations`;

const ListObservations = (schoolId, trainingId, accessToken, studentId, options = {}) => {
  return useQuery(
    ["student-observations", schoolId, trainingId, studentId],
    async () => {
      const response = await fetch(observationsUrl(schoolId, trainingId, studentId), {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result?.error || "Erreur de récupération des observations!");
      }
      return result;
    },
    {
      enabled: !!studentId && options.enabled !== false,
      refetchOnWindowFocus: false,
    }
  );
};

const CreateObservation = async (schoolId, trainingId, accessToken, studentId, message) => {
  const response = await fetch(observationsUrl(schoolId, trainingId, studentId), {
    method: "POST",
    body: JSON.stringify({ message }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || "Erreur lors de l'ajout de l'observation!");
  }
  return result;
};

const DeleteObservation = async (schoolId, trainingId, accessToken, studentId, observationId) => {
  const response = await fetch(`${observationsUrl(schoolId, trainingId, studentId)}/${observationId}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || "Erreur lors de la suppression de l'observation!");
  }
  return result;
};

const ListTrainingObservations = (schoolId, trainingId, accessToken, page = 1, pageSize = 50, filter = {}) => {
  return useQuery(
    ["training-student-observations", schoolId, trainingId, page, pageSize, JSON.stringify(filter)],
    async () => {
      const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
      Object.entries(filter || {}).forEach(([key, value]) => {
        if (value) {
          params.set(key, value);
        }
      });
      const response = await fetch(
        `${BACKEND_URL}/api/v1/schools/${schoolId}/trainings/${trainingId}/student-observations?${params.toString()}`,
        {
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result?.error || "Erreur de récupération des observations!");
      }
      return result;
    },
    { enabled: !!schoolId && !!trainingId, keepPreviousData: true, refetchOnWindowFocus: false }
  );
};

const FetchOne = async (schoolId, trainingId, accessToken, studentId) => {
  const response = await fetch(`${BACKEND_URL}/api/v1/schools/${schoolId}/trainings/${trainingId}/students/${studentId}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || "Erreur de récupération de l'élève!");
  }
  return result;
};

const NotifyObservation = async (schoolId, trainingId, accessToken, studentId, observationId) => {
  const response = await fetch(`${observationsUrl(schoolId, trainingId, studentId)}/${observationId}/notify`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || "Erreur lors de la notification des parents!");
  }
  return result;
};

const CreateOne = async (schoolId, trainingId, accessToken, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      let error = await response.json();
      throw new Error(error?.error || "Erreur de création du dossier de candidature!");
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateOne = async (
  schoolId,
  trainingId,
  accessToken,
  studentId,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification des informations de l'élève!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateClass = async (
  schoolId,
  trainingId,
  accessToken,
  studentId,
  classId,
  levelId
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/class",
      {
        method: "PATCH",
        body: JSON.stringify({ class_id: classId, level_id: levelId }),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification de la classe de l'élève!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateStatus = async (
  schoolId,
  trainingId,
  accessToken,
  studentId,
  newStatus,
  registrationConfirmationById,
  registrationConfirmationDetails,
  unregistrationReason,
  onWaitingListDetails
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/status",
      {
        method: "PATCH",
        body: JSON.stringify({
          new_status: newStatus,
          registration_confirmation_by_id: registrationConfirmationById,
          registration_confirmation_details: registrationConfirmationDetails,
          unregistration_reason: unregistrationReason,
          on_waiting_list_details: onWaitingListDetails,
        }),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification du status de l'élève!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateResult = async (
  schoolId,
  trainingId,
  accessToken,
  studentId,
  newResult,
  resultObservation,
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/result",
      {
        method: "PATCH",
        body: JSON.stringify({ result: newResult, result_observation: resultObservation }),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification de l'avis de passage de l'élève!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateConfirmation = async (
  schoolId,
  trainingId,
  accessToken,
  studentId,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/confirmation",
      {
        method: "PATCH",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification du status de l'élève!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdatePreviousTrainingInfos = async (
  schoolId,
  trainingId,
  accessToken,
  studentId
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/update-previous-training-infos",
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de mise à jours de informations la formation précédente`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteOne = async (schoolId, trainingId, accessToken, studentId) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression de l'élève!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const SendContactEmail = async (schoolId, trainingId, accessToken, studentId, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/contact-email",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    const actualData = await response.json();
    if (!response.ok) {
      throw new Error(actualData?.error || "Erreur d'envoi du mail de contact!");
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateFatherInfos = async (schoolId, trainingId, studentId, data) => {

  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/update-father-infos",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let actualData = await response.json();
    if (!response.ok) {
      throw new Error(`Erreur de modification des informations du père! ${actualData?.error}`);
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const ChangeFather = async (schoolId, trainingId, studentId, fatherId) => {

  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/change-father",
      {
        method: "POST",
        body: JSON.stringify({
          father_id: fatherId,
        }),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let actualData = await response.json();
    if (!response.ok) {
      throw new Error(`Erreur de modification des informations du père! ${actualData?.error}`);
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteFather = async (schoolId, trainingId, studentId) => {

  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/remove-father",

      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur de suppression du père!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateMotherInfos = async (schoolId, trainingId, studentId, data) => {

  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/update-mother-infos",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let actualData = await response.json();
    if (!response.ok) {
      throw new Error(`Erreur de modification des informations de la mère! ${actualData?.error}`);
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const ChangeMother = async (schoolId, trainingId, studentId, motherId) => {

  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/change-mother",
      {
        method: "POST",
        body: JSON.stringify({
          mother_id: motherId,
        }),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let actualData = await response.json();
    if (!response.ok) {
      throw new Error(`Erreur de modification des informations de la mère! ${actualData?.error}`);
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteMother = async (schoolId, trainingId, studentId) => {

  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/students/" +
      studentId +
      "/remove-mother",

      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur de suppression de la mère!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const GetUpdatesHistory = (schoolId, trainingId, accessToken, studentId) => {
  return useQuery(
    ["student-updates-history", schoolId, trainingId, accessToken, studentId],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL +
          "/api/v1/schools/" +
          schoolId +
          "/trainings/" +
          trainingId +
          "/students/" +
          studentId +
          "/updates",
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`Erreur de récupération de l'historique des modifications!`);
        }
        let actualData = await response.json();
        return actualData;
      } catch (err) {
        throw err;
      }
    }
  );
};

const useGetEnrolledList = (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  return useQuery(
    ["students-enrolled", schoolId, trainingId, accessToken, page, pageSize, filter],
    async () => {
      let searchName = filter?.name || "";
      let classId = filter?.class_id || "";
      let slotId = filter?.slot_id || "";
      let teacherId = filter?.teacher_id || "";
      let classroomId = filter?.classroom_id || "";
      let minAbsences = filter?.min_absences || "";
      let minRetards = filter?.min_retards || "";

      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/students-enrolled?page=${page}&pageSize=${pageSize}&name=${searchName}&class_id=${classId}&slot_id=${slotId}&teacher_id=${teacherId}&classroom_id=${classroomId}&min_absences=${minAbsences}&min_retards=${minRetards}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch enrolled students!");
        }
        if (response.status >= 299) {
          throw new Error("Erreur de récupération de la liste des élèves inscrits!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error fetching enrolled students:", error);
        throw error;
      }
    },
    {
      keepPreviousData: true,
      staleTime: 30000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 1000,
    }
  );
};

const studentsAPI = {
  useGetList,
  useGetOngoingList,
  useGetEnrolledList,
  SearchStudent,
  GetOne,
  ListSiblings,
  ListAttendances,
  ListObservations,
  CreateObservation,
  DeleteObservation,
  NotifyObservation,
  ListTrainingObservations,
  FetchOne,
  CreateOne,
  UpdateOne,
  UpdateClass,
  UpdateStatus,
  UpdateResult,
  UpdateConfirmation,
  UpdatePreviousTrainingInfos,
  DeleteOne,
  SendContactEmail,
  UpdateFatherInfos,
  ChangeFather,
  DeleteFather,
  UpdateMotherInfos,
  ChangeMother,
  DeleteMother,
  GetUpdatesHistory,
};

export default studentsAPI;
